export enum ConditionType {
    Operation = 'OPERATION',
    Input = 'INPUT',
    UI = 'UI',
}